const getAPIErrorHandler = (customCallback) => {
  return (response, action, defaultCallback) => {
    customCallback()
    defaultCallback(response, action)
  }
}

export const getDefaultCallbacks = (customCallback) => ({
  400: getAPIErrorHandler(customCallback),
  422: getAPIErrorHandler(customCallback),
  error: getAPIErrorHandler(customCallback)
})
